import { graphql } from "gatsby";
import React from "react";
import ArtworkDetail from "../../components/artwork-detail";
import Layout from "../../components/layout";

export default function ArtworkPage({data: {artwork}}) {
    return <Layout title={`${artwork.title} by ${artwork.artist}`}><ArtworkDetail art={artwork} /></Layout>
}

export const query = graphql`
query($id: String) {
    artwork(id: {eq: $id}) {
      id
      address
      app_colour
      artist
      artist_bio
      artist_website
      artist_ig_profile
      artist_contact
      artist_bio_short
      coords
      image_url
      location
      keywords
      more_info_file
      materials
      more_info_url
      photographer
      region
      status
      summary
      title
      type
    }
  }
`